









import { defineComponent, computed } from '@vue/composition-api'

enum MemberStatus {
  Free = 'Free',
  Premium = 'Premium',
  Expired = 'Expired',
  Deleted = 'Deleted'
}

const capitalize = (s: string) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export default defineComponent({
  name: 'MemberStatusBadge',

  props: {
    user: {
      type: Object,
      default: null
    },
    status: {
      type: String,
      default: null
    }
  },

  setup(props) {
    if (props.user == null && props.status == null) {
      console.warn('user and status are both empty')
    }

    const status = computed(() => {
      if (props.status) {
        return capitalize(props.status)
      }

      if (props.user == null) {
        return 'unknown'
      }
      // eslint-disable-next-line
      const user = props.user as any
      if (user.deleted) {
        return MemberStatus.Deleted
      }

      const now = new Date()
      return user.expires_at
        ? new Date(user.expires_at) > now
          ? MemberStatus.Premium
          : MemberStatus.Expired
        : MemberStatus.Free
    })

    const classes = computed(() => {
      switch (status.value) {
        case MemberStatus.Deleted:
          return ['bg-red-200', 'text-red-600']

        case MemberStatus.Free:
          return ['bg-gray-200', 'text-gray-600']

        case MemberStatus.Premium:
          return ['bg-teal-200', 'text-teal-800']

        case 'Premium_expired':
          return ['bg-orange-200', 'text-orange-600']
        case 'Trial_expired':
          return ['bg-orange-200', 'text-orange-600']
        case MemberStatus.Expired:
          return ['bg-orange-200', 'text-orange-600']

        default:
          return ['bg-purple-200', 'text-purple-600']
      }
    })

    return {
      statusText: status,
      classes
    }
  }
})
